import ApiRequests from "../apiRequests";

class ImageService extends ApiRequests {
  constructor() {
    super("images");
  }
}

export default ImageService;
